export default __webpack_public_path__ + "static/media/Reload-Logo-Pill.4a7dee0a.png";